export default "__VITE_ASSET__CJOMVbTF__"